import Vue from 'vue';
import t from './template.vue';

var vList = [];

export function show(){
    var voteExtend = Vue.extend(t);
    let _instance = new voteExtend();
    _instance.$mount();
    document.body.appendChild(_instance.$el);
    vList.push(_instance);
}

export function hide(){
    while(vList.length>0){
        var _instance = vList.pop();
        _instance.$el.remove();
        _instance.$destroy();
    }
}